import { useEffect, useState } from 'react';
import { hrApi } from '../../api/hr.js';
import { useAuth } from '../../contexts/AuthContext.jsx';

export default function Performance() {
  const { can } = useAuth();
  const isReviewer = can('performance_review', 'create');
  const [employees, setEmployees] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [editing, setEditing] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isReviewer) hrApi.listEmployees({ limit: 200 }).then((d) => setEmployees(d?.items || []));
    hrApi.reviews().then((d) => setReviews(d?.items || []));
  }, [isReviewer]);

  function refresh() {
    hrApi.reviews().then((d) => setReviews(d?.items || []));
  }

  function newReview() {
    setEditing({
      employeeId: employees[0]?.id || '',
      period: `${new Date().getFullYear()}-Q${Math.floor(new Date().getMonth() / 3) + 1}`,
      rating: 3,
      strengths: '',
      improvements: '',
      comments: '',
      status: 'draft',
    });
  }

  async function save(e) {
    e.preventDefault();
    setError(null);
    try {
      if (editing.id) {
        await hrApi.saveReview(editing);
      } else {
        await hrApi.saveReview(editing);
      }
      setEditing(null);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed');
    }
  }

  return (
    <section>
      <header className="page-header">
        <h1>Performance Reviews</h1>
        {isReviewer && <button className="btn primary" onClick={newReview}>+ New Review</button>}
      </header>

      {error && <div className="alert error">{error}</div>}

      {editing && (
        <form onSubmit={save} className="card form-card grid-form">
          <h3 className="full">{editing.id ? 'Edit review' : 'New review'}</h3>
          {!editing.id && (
            <label className="full">
              Employee
              <select value={editing.employeeId} onChange={(e) => setEditing({ ...editing, employeeId: e.target.value })} required>
                <option value="">Select…</option>
                {employees.map((e) => <option key={e.id} value={e.id}>{e.user_name}</option>)}
              </select>
            </label>
          )}
          <label>Period<input value={editing.period} onChange={(e) => setEditing({ ...editing, period: e.target.value })} required placeholder="e.g. 2026-Q2" /></label>
          <label>
            Rating
            <select value={editing.rating || ''} onChange={(e) => setEditing({ ...editing, rating: Number(e.target.value) })}>
              {[1, 2, 3, 4, 5].map((n) => <option key={n} value={n}>{n} ★</option>)}
            </select>
          </label>
          <label className="full">Strengths<textarea rows={3} value={editing.strengths || ''} onChange={(e) => setEditing({ ...editing, strengths: e.target.value })} /></label>
          <label className="full">Areas to improve<textarea rows={3} value={editing.improvements || ''} onChange={(e) => setEditing({ ...editing, improvements: e.target.value })} /></label>
          <label className="full">General comments<textarea rows={3} value={editing.comments || ''} onChange={(e) => setEditing({ ...editing, comments: e.target.value })} /></label>
          <label>Status
            <select value={editing.status} onChange={(e) => setEditing({ ...editing, status: e.target.value })}>
              <option value="draft">Draft</option>
              <option value="submitted">Submitted</option>
            </select>
          </label>
          <div className="full actions">
            <button type="button" className="btn ghost" onClick={() => setEditing(null)}>Cancel</button>
            <button type="submit" className="btn primary">Save</button>
          </div>
        </form>
      )}

      <div className="card">
        <h3>All reviews</h3>
        <table className="data-table">
          <thead><tr><th>Employee</th><th>Period</th><th>Reviewer</th><th>Rating</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {reviews.map((r) => (
              <tr key={r.id}>
                <td>{r.employee_name || '—'} <span className="muted small">{r.employee_code}</span></td>
                <td>{r.period}</td>
                <td className="muted">{r.reviewer_name || '—'}</td>
                <td>{r.rating ? `${'★'.repeat(r.rating)}` : '—'}</td>
                <td><span className={`chip status-${r.status}`}>{r.status}</span></td>
                <td>{isReviewer && <button className="btn ghost small" onClick={() => setEditing({ ...r, employeeId: r.employee_id })}>Edit</button>}</td>
              </tr>
            ))}
            {reviews.length === 0 && <tr><td colSpan={6} className="muted">No reviews yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
